import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { retrieveProfileData } from "../../../api/PupilApi"; // You'll need to create this API function

const MyProfileFromAdmin = () => {
    const navigate = useNavigate();
    const { customerEmail } = useParams(); // Get customerEmail from URL params
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        
        if (!customerEmail) {
            setError("Customer email not provided");
            setLoading(false);
            return;
        }

        // Replace retrieveProfile with getCustomerProfile that takes customerEmail
        retrieveProfileData(customerEmail)
            .then((res) => {
                setUser(res.data || res);
                setLoading(false);
                console.log("CUSTOMER DATA RECEIVED SUCCESSFULLY:", res);
            })
            .catch((err) => {
                setError("Failed to fetch customer profile data. Please try again later.");
                console.error(err);
                setLoading(false);
            });
    }, [customerEmail]);

    if (loading)
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-amber-500 mx-auto"></div>
                    <p className="mt-4 text-lg font-medium text-gray-700">
                        Loading customer profile...
                    </p>
                </div>
            </div>
        );

    if (error)
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
                <div className="bg-white p-6 rounded-xl shadow-md max-w-md w-full text-center">
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                        <svg
                            className="h-6 w-6 text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="mt-3 text-lg font-medium text-gray-900">
                        Error loading profile
                    </h3>
                    <p className="mt-2 text-sm text-gray-500">{error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-amber-600 hover:bg-amber-700"
                    >
                        Try Again
                    </button>
                    <button
                        onClick={() => navigate("/viewCustomers")}
                        className="mt-4 ml-2 inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50"
                    >
                        Back to Customers
                    </button>
                </div>
            </div>
        );

    if (!user) return null;

    return (
        <div className="min-h-screen bg-gray-50 py-4 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                {/* Back button for mobile */}
                <button
                    onClick={() => navigate("/viewCustomers")}
                    className="mb-4 flex items-center text-amber-600 hover:text-amber-800"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                            clipRule="evenodd"
                        />
                    </svg>
                    Back to Customers
                </button>

                <div className="bg-white shadow-xl rounded-xl overflow-hidden">
                    {/* Header Section */}
                    <div className="bg-gradient-to-r from-amber-600 to-amber-700 p-4 sm:p-6 text-white">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-4 sm:space-y-0">
                            <div>
                                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">
                                    {user.name || "Unknown Customer"}
                                </h1>
                                <p className="text-amber-100 mt-1 text-sm sm:text-base">
                                    Customer Profile - {customerEmail}
                                </p>
                                <p className="text-amber-200 text-xs mt-1">
                                    Managed by Admin
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => navigate("/viewCustomers")}
                                    className="hidden md:flex items-center px-4 py-2 bg-white text-amber-600 font-medium rounded-lg hover:bg-amber-50 transition-colors duration-200 shadow-sm"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 mr-2"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    Back to Customers
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Basic Info Section */}
                    <div className="p-4 sm:p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <InfoCard label="Mobile" value={user.pupilMobile} icon="phone" />
                        <InfoCard label="Status" value={user.status} icon="status" />
                        <InfoCard label="Aadhar No" value={user.aadhar || user.aadharNo} icon="id" />
                        <InfoCard label="PAN" value={user.pan} icon="id" />
                        <InfoCard label="Category" value={user.category} icon="office" />
                        <InfoCard label="Role" value={user.role} icon="user" />
                    </div>

                    {/* Plans Section */}
                    <div className="border-t border-gray-200 px-4 sm:px-6 py-4 sm:py-6">
                        <div className="flex justify-between items-center mb-4 sm:mb-6">
                            <h2 className="text-lg sm:text-xl font-bold text-gray-800">
                                Customer Plans
                            </h2>
                            <span className="text-sm text-gray-500">
                                Admin Management View
                            </span>
                        </div>
                        <YourPlans user={user} customerEmail={customerEmail} />
                    </div>

                    {/* Additional Customer Data Sections */}
                    {(user.chitData || user.GoldChitOnboard || user.personalLoanData) && (
                        <div className="border-t border-gray-200 px-4 sm:px-6 py-4 sm:py-6">
                            <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 sm:mb-6">
                                Additional Data
                            </h2>
                            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                                {user.chitData && (
                                    <DataCard 
                                        title="Chit Data" 
                                        data={user.chitData}
                                        type="chit"
                                    />
                                )}
                                {user.GoldChitOnboard && (
                                    <DataCard 
                                        title="Gold Chit Data" 
                                        data={user.GoldChitOnboard}
                                        type="gold"
                                    />
                                )}
                                {user.personalLoanData && user.personalLoanData.length > 0 && (
                                    <DataCard 
                                        title="Personal Loan Data" 
                                        data={user.personalLoanData}
                                        type="loan"
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const InfoCard = ({ label, value, icon }) => {
    const getIcon = () => {
        switch (icon) {
            case "mail":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                );
            case "phone":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                );
            case "user":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                );
            case "status":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                );
            case "id":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                    </svg>
                );
            case "office":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                );
            case "badge":
                return (
                    <svg className="h-5 w-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                );
            default:
                return null;
        }
    };

    return (
        <div className="bg-gray-50 p-3 sm:p-4 rounded-lg flex items-start space-x-3">
            <div className="flex-shrink-0 mt-0.5">{getIcon()}</div>
            <div>
                <h3 className="text-xs sm:text-sm font-medium text-gray-500">{label}</h3>
                <p className="mt-1 text-sm sm:text-base font-semibold text-gray-900 break-all">
                    {value || "-"}
                </p>
            </div>
        </div>
    );
};

const YourPlans = ({ user, customerEmail }) => {
    const navigate = useNavigate();

    const handleAddPlan = (planType) => {
        // Navigate to plan creation page with customer email
        switch(planType) {
            case 'gold':
                navigate(`/admin/add-gold-plan/${customerEmail}`);
                break;
            case 'chit':
                navigate(`/admin/add-chit-plan/${customerEmail}`);
                break;
            case 'loan':
                navigate(`/admin/add-personal-loan/${customerEmail}`);
                break;
            default:
                break;
        }
    };

    const plans = [
        {
            title: "Gold Chit Plan",
            description: "Save monthly and collect gold at maturity.",
            path: `/profileview/${customerEmail}`,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2-1.343-2-3-2zm0 0v-2m0 2v2m0 4v2m-6-6h12" />
                </svg>
            ),
            state: user.goldPlanDetails || user.GoldChitOnboard,
            type: 'gold',
            hasPlan: !!(user.plans || user.plans)
        },
        {
            title: "Money Chit Plan",
            description: "Contribute monthly and get lump sum returns.",
            path: `/profileviewMoneyChit/${customerEmail}`,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2-1.343-2-3-2zm0 0V6m0 2v2m0 4v2m-6-6h12" />
                </svg>
            ),
            state: user.chitPlanDetails || user.chitData,
            type: 'chit',
            hasPlan: !!(user.chitPlanDetails || user.chitData)
        },
        {
            title: "Personal Loan",
            description: "Apply for instant personal loans with flexible EMIs.",
            path: `/profileviewPersonalLoan/${customerEmail}`,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a5 5 0 00-10 0v2M5 9h14l1 12H4L5 9z" />
                </svg>
            ),
            type: 'loan',
            hasPlan: !!(user.personalLoanData && user.personalLoanData.length > 0)
        },
    ];

    return (
        <div className="py-8 px-4 bg-gray-50 rounded-lg">
            <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
                Customer Plans Management
            </h2>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {plans.map((plan, index) => (
                    <div key={index} className="bg-white shadow-md rounded-2xl p-6 text-center hover:shadow-lg transition">
                        <div className="flex justify-center">{plan.icon}</div>
                        <h3 className="mt-4 text-lg font-medium text-gray-900">
                            {plan.title}
                        </h3>
                        <p className="mt-2 text-sm text-gray-500">{plan.description}</p>
                        
                        <div className="mt-4 flex flex-col space-y-2">
                            {plan.hasPlan ? (
                                <Link to={plan.path}>
                                    <button className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors">
                                        View Details
                                    </button>
                                </Link>
                            ) : (
                                <button 
                                    onClick={() => handleAddPlan(plan.type)}
                                    className="w-full px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
                                >
                                    Add Plan
                                </button>
                            )}
                            
                            {plan.hasPlan && (
                                <button 
                                    onClick={() => handleAddPlan(plan.type)}
                                    className="w-full px-4 py-2 border border-amber-600 text-amber-600 rounded-lg hover:bg-amber-50 transition-colors"
                                >
                                    Add Another
                                </button>
                            )}
                        </div>
                        
                        <div className="mt-3">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                plan.hasPlan 
                                    ? 'bg-green-100 text-green-800' 
                                    : 'bg-gray-100 text-gray-800'
                            }`}>
                                {plan.hasPlan ? 'Active' : 'Not Added'}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const DataCard = ({ title, data, type }) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow border">
            <h3 className="font-semibold text-gray-800 mb-2">{title}</h3>
            <div className="text-sm text-gray-600 max-h-32 overflow-y-auto">
                <pre className="whitespace-pre-wrap text-xs">
                    {JSON.stringify(data, null, 2)}
                </pre>
            </div>
        </div>
    );
};

export default MyProfileFromAdmin;